import React from 'react'
import ToolPageLayout2col from '../ToolPageLayout2col'
import BrandTemplatesDownload from './BrandTemplatesDownload'
import TemplatesImport from './TemplatesImport'

export default function BrandTemplatesManagePage() {
  return (
    <ToolPageLayout2col>
      <BrandTemplatesDownload />
      <TemplatesImport />
    </ToolPageLayout2col>
  )
}
